import {useSelector} from 'react-redux';
import {connectionError} from '../../store/reducers/ward';
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from 'react-i18next';
import {Dialog} from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: '#f4c3c6',
        border: 'solid 2px #70191c',
        color: '#70191c',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        padding: 15,
        borderRadius: 8,
    },
    activeLink: {
        padding: '0 5px',
        color: '#2180f7',
        cursor: 'pointer',
        textDecoration: 'underline',
    },
}));

const ServiceTemporarilyUnavailable = () => {
    const classes = useStyles();
    const {t} = useTranslation();
    const connectionErrorObject = useSelector(connectionError);

    const handleRefresh = () => {
        window.location.reload();
    };

    if (!connectionErrorObject) return null;

    return (
        <Dialog
            open={connectionErrorObject}
            fullWidth
            PaperProps={{sx: {borderRadius: '8px'}}}
        >
            <div className={classes.root}>
                <ErrorIcon style={{fontSize: 48}}/>

                <div style={{fontWeight: 'bold', fontSize: 'large'}}>
                    {t('SERVICE TEMPORARILY UNAVAILABLE')}
                </div>

                <div>
                    <span>
                        {t('Please')}
                    </span>

                    <span className={classes.activeLink} onClick={handleRefresh}>
                        {t('refresh')}
                    </span>

                    <span>
                        {t('the website, wait or contact the administration')}
                    </span>
                </div>

                <div>
                    {t('Sorry for the inconvenience')}
                </div>
            </div>
        </Dialog>
    );
};

export default ServiceTemporarilyUnavailable;

